import { Button, Divider } from '@mui/material';
import { SearchRounded } from '@mui/icons-material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '@src/components/Tooltip';
import { COLOR } from '@src/styles/color';

const SearchAndReplace = ({ handleClickOpenBonusToolbar }) => {
  const { t } = useTranslation();

  return (
    <div className="group group-search-and-replace">
      <Tooltip arrow title={t('searchAndReplace')} placement="top">
        <Button
          data-id="open-find-and-replace"
          id="search-and-replace"
          className="custom-button search-and-replace"
          onClick={handleClickOpenBonusToolbar}
          color="iconPrimary"
        >
          <SearchRounded sx={{ fontSize: 24, color: COLOR.navyBlue }} />
        </Button>
      </Tooltip>
      <Divider orientation="vertical" flexItem className="divider" />
    </div>
  );
};
export default SearchAndReplace;
